module.exports = __webpack_public_path__ + "3a49adc9a786ccc7356cb386d51184ba.svg";